import { createClient } from '@supabase/supabase-js'
import type { Database } from '@/types/database'

function requireEnv(name: string): string {
  const value = import.meta.env[name as keyof ImportMetaEnv]
  if (!value) {
    throw new Error(`Missing required environment variable: ${name}`)
  }
  return value
}

const USE_LOCAL_DATABASE = import.meta.env.VITE_USE_LOCAL_DATABASE === 'true'
const USE_LOCAL_FUNCTIONS = import.meta.env.VITE_USE_LOCAL_FUNCTIONS === 'true'

const SUPABASE_URL = USE_LOCAL_DATABASE
  ? import.meta.env.VITE_LOCAL_SUPABASE_URL || 'http://127.0.0.1:54621'
  : requireEnv('VITE_SUPABASE_URL')

const SUPABASE_ANON_KEY = USE_LOCAL_DATABASE
  ? import.meta.env.VITE_LOCAL_SUPABASE_ANON_KEY || import.meta.env.VITE_SUPABASE_ANON_KEY
  : import.meta.env.VITE_SUPABASE_ANON_KEY

if (!SUPABASE_ANON_KEY) {
  throw new Error(
    USE_LOCAL_DATABASE
      ? 'Missing Supabase anon key. Set VITE_LOCAL_SUPABASE_ANON_KEY (preferred) or VITE_SUPABASE_ANON_KEY.'
      : 'Missing required environment variable: VITE_SUPABASE_ANON_KEY'
  )
}

const EDGE_FUNCTIONS_URL = USE_LOCAL_FUNCTIONS
  ? import.meta.env.VITE_LOCAL_EDGE_FUNCTIONS_URL || 'http://127.0.0.1:54621/functions/v1'
  : `${requireEnv('VITE_SUPABASE_URL')}/functions/v1`

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    flowType: 'pkce',
  },
})

export function getSupabaseUrl(): string {
  return SUPABASE_URL
}

export function getAnonKey(): string {
  return SUPABASE_ANON_KEY
}

export function getEdgeFunctionsUrl(): string {
  return EDGE_FUNCTIONS_URL
}

export function isLocalDatabase(): boolean {
  return USE_LOCAL_DATABASE
}

export function isLocalFunctions(): boolean {
  return USE_LOCAL_FUNCTIONS
}

// Log environment info in development
if (import.meta.env.DEV) {
  console.log(`
╔════════════════════════════════════════════════════════════╗
║           ITS ONE NUMBER - ENVIRONMENT CONFIG              ║
╠════════════════════════════════════════════════════════════╣
║  ${USE_LOCAL_DATABASE ? '🔧' : '🚀'} Database:       ${USE_LOCAL_DATABASE ? 'LOCAL' : 'PRODUCTION'}                              ║
║  ${USE_LOCAL_FUNCTIONS ? '🔧' : '🚀'} Edge Functions: ${USE_LOCAL_FUNCTIONS ? 'LOCAL' : 'PRODUCTION'}                              ║
╚════════════════════════════════════════════════════════════╝
  `)
}
